import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "accessLevelsEditorPanel";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
